import { UrlMatcher, UrlSegment } from '@angular/router';

/**
 * @description 
 *  - Custom URL matcher to identify and redirect old 'water-flow-intelligence' routes to new 'water-track-iq' routes.
 *  - This matcher checks if the first segment of the URL is 'water-flow-intelligence'.
 *  - If a match is found, it triggers the wfiRedirectGuard to handle the redirection.
 * 
 * @param url 
 *  - The array of URL segments to be matched. 
 * @returns 
 *  - An object with the consumed URL segments if a match is found, otherwise undefined.
 */

export const wfiRedirectMatcher: UrlMatcher = (url: UrlSegment[]) => {
  if (url?.length && url[0]?.path === 'water-flow-intelligence') {
    return { consumed: url };
  }
};